import React from 'react';

import { Stack, Typography } from '@mui/material';
import { ButtonWithIcon } from 'src/v2/components/ui/buttons/buttonWithIcon';
import { ImmuneFiLogoV2, RiskDAOLogoV2, VerilogLogoV2 } from 'src/v2/components/ui/images';

import { primaryColors } from '~components/theme/styles/colors';

import SlideWrapper from '../SlideWrapper';

const RISK_DAO_BG =
  'linear-gradient(278.18deg, rgba(124, 79, 219, 0.8) -7.61%, rgba(0, 251, 234, 0.5) 39.1%, #B5EDFF 83.03%), #FFFFFF';

function SecurePartnersSlide() {
  return (
    <SlideWrapper
      sx={{
        background: RISK_DAO_BG,
        textAlign: 'center',
        justifyContent: 'space-around',
        py: 8,
      }}
    >
      <Stack sx={{ alignItems: 'center', justifyContent: 'center' }} spacing={6}>
        <Typography variant="h6" color={primaryColors[900]}>
          Secured by professional risk managers
        </Typography>
        <RiskDAOLogoV2 background="black" />
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={4}>
          <ButtonWithIcon
            iconType="asterisk"
            sx={{ color: 'black', borderColor: 'black', width: 320 }}
            variant={'secondary'}
          >
            COLLATERAL PARAMETER ANALYSIS
          </ButtonWithIcon>
          <ButtonWithIcon
            iconType="asterisk"
            sx={{ color: 'black', borderColor: 'black', width: 320 }}
            variant={'secondary'}
          >
            RISK DAO VESTA DASHBOARD
          </ButtonWithIcon>
        </Stack>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={8}>
          <Stack direction={'row'} spacing={2}>
            <Typography variant={'h6'} color={primaryColors[900]}>
              Audited by
            </Typography>
            <VerilogLogoV2 background={primaryColors[900]} />
          </Stack>
          <Stack direction={'row'} spacing={2}>
            <Typography variant={'h6'} color={primaryColors[900]}>
              Secured by
            </Typography>
            <ImmuneFiLogoV2 background={primaryColors[900]} />
          </Stack>
        </Stack>
      </Stack>
    </SlideWrapper>
  );
}

export default SecurePartnersSlide;
